import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        if (res.data.session_token) setToken(res.data.session_token);
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(res.data.onboarded ? "/" : "/onboarding", { replace: true, state: { user: res.data } });
      } catch {
        setError(true);
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="h-screen w-full flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="font-display text-3xl font-semibold tracking-tight">AIRTIME</div>
        <div className="text-sm text-muted-foreground mt-2">
          {error ? "Connexion échouée. Réessaie." : "Connexion en cours…"}
        </div>
      </div>
    </div>
  );
}
